<template>
    <div class="compare-table">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane v-if="callBidDocInfo.goodsFlag" label="商品" name="goods">
                <table class="custom-tbl compare-box">
                    <thead class="head operate-table">
                    <tr class="row">
                        <th class="align-left">
                            <div class="setbox">
                                <p class="ellipsis-1" :title="callBidDocInfo.title">{{callBidDocInfo.title}}</p>
                            </div>
                        </th>
                        <th v-for="(bidParity, index) in bidParityList">
                            <div class="compare-item">
                                <a class="ellipsis-1" :title="bidParity.merchantName">{{bidParity.merchantName}}</a>
                                <span>总报价（元）</span>
                                <span class="price fr">{{bidParity.offerPrice || '无'}}</span>
                                <i @click="removeBidParity(index)" class="close-icon">×</i>
                            </div>
                        </th>
                    </tr>
                    </thead>
                    <tbody class="body content-table">
                    <tr v-for="(value, key) in callGoodsMap" class="row">
                        <td>
                            <div class="compare-name">
                                <p class="font12">{{value.name}}</p>
                                <p class="font12">
                                    平均价（元）<span class="font-red">{{(value.sumPrice / value.sumQuantity).toFixed(2)}}</span>
                                </p>
                            </div>
                        </td>
                        <td v-for="bidGoods in bidGoodsMap[key]" class="">
                            <div v-if="bidGoods != null" class="compare-info">
                                <div class="textbox">
                                    <div class="image">
                                        <img :src="bidGoods.skuDefaultImageUrl"/>
                                    </div>
                                    <div class="text" style="padding-left: 5px;">
                                        <p class="align-left ellipsis-1" :title="bidGoods.name">{{bidGoods.name}}</p>
                                        <p class="align-left">{{bidGoods.brandName}}</p>
                                    </div>
                                </div>
                                <div class="pricebox">
                                    <div class="price-group">
                                        <div class="label">报价（元）：</div>
                                        <div class="value" :class="{'font-red': (bidGoods.price > (value.sumPrice / value.sumQuantity)),'font-green' : (bidGoods.price <= (value.sumPrice / value.sumQuantity))}">
                                            <span>{{bidGoods.price.toFixed(2)}}</span>
                                        </div>
                                    </div>
                                    <!--<p class="align-right swb-btn-link display-block font12">更多</p>-->
                                </div>
                            </div>
                            <div class="compare-info" v-else>

                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </el-tab-pane>
            <el-tab-pane v-if="callBidDocInfo.servcFlag" label="服务" name="servc">
                <table class="custom-tbl compare-box">
                    <thead class="head operate-table">
                    <tr class="row">
                        <th class="align-left">
                            <div class="setbox">
                                <p class="ellipsis-1" :title="callBidDocInfo.title">{{callBidDocInfo.title}}</p>
                            </div>
                        </th>
                        <th v-for="(bidParity, index) in bidParityList">
                            <div class="compare-item">
                                <a class="ellipsis-1" :title="bidParity.merchantName">{{bidParity.merchantName}}</a>
                                <span>总报价（元）</span>
                                <span class="price fr">{{bidParity.offerPrice || '无'}}</span>
                                <i @click="removeBidParity(index)" class="close-icon">×</i>
                            </div>
                        </th>
                    </tr>
                    </thead>
                    <tbody class="body content-table">
                    <tr v-for="(value, key) in callServcsMap" class="row">
                        <td>
                            <div class="compare-name">
                                <p class="font12">{{value.name}}</p>
                                <p class="font12">
                                    平均价（元）<span class="font-red">{{(value.sumPrice / value.sumQuantity).toFixed(2)}}</span>
                                </p>
                            </div>
                        </td>
                        <td v-for="bidServc in bidServcsMap[key]" class="">
                            <div v-if="bidServc != null" class="compare-info">
                                <div class="textbox">
                                    <div class="text" style="padding-left: 5px;">
                                        <p class="align-left ellipsis-1" :title="bidServc.name">{{bidServc.name}}</p>
                                        <p class="align-left">{{bidServc.brandName}}</p>
                                    </div>
                                </div>
                                <div class="pricebox">
                                    <div class="price-group">
                                        <div class="label">报价（元）：</div>
                                        <div class="value" :class="{'font-red': (bidServc.price > (value.sumPrice / value.sumQuantity)),'font-green' : (bidServc.price <= (value.sumPrice / value.sumQuantity))}">
                                            <span>{{bidServc.price.toFixed(2)}}</span>
                                        </div>
                                    </div>
                                    <p class="align-right swb-btn-link display-block font12">更多</p>
                                </div>
                            </div>
                            <div class="compare-info" v-else>

                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import { Utils, Store } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import callBidApi from '../../api/callBid'
    //
    //
    function getStore() {
        if(typeof Store != 'undefined') {
            return Store;
        } else {
            console.warn('请确保引入了 store.js');
        }
        //
        return null;
    }
    //
    export default{
        name: 'swb-bid-parity',
        desc: '比价',
        props: ['callBidDocId'],
        data: function () {
            return {
                activeName: 'goods',
                callBidDocInfo: {},
                bidParityKey: "bidParityKey",
                bidParityList: [],
                callGoodsMap: {},
                bidGoodsMap: {},
                callServcsMap: {},
                bidServcsMap: {}
            }
        },
        created: function () {
            this.getCallBidDocInfo();
        },
        methods: {
            handleClick: function (tab, event) {

            },
            getBidParityList: function () {
                let callBidDocInfo = this.callBidDocInfo;
                let servcFlag = callBidDocInfo.servcFlag;
                let goodsFlag = callBidDocInfo.goodsFlag;
                let callGoodsMap = this.callGoodsMap;
                let callServcsMap = this.callServcsMap;
                let bidGoodsMap = Utils.KeyMap.from();
                let bidServcsMap = Utils.KeyMap.from();
                let store = getStore() || {};
                let bidParityList = store.get(this.bidParityKey) || [];
                if(bidParityList != null && bidParityList.length > 0) {
                    for(let i = 0; i < bidParityList.length; i++) {
                        let bidItem = bidParityList[i];
                        let goodsList = bidItem.bidGoodsList;
                        if(goodsList != null && goodsList.length > 0) {
                            for(let i = 0; i < goodsList.length; i++) {
                                let goods = goodsList[i];
                                //
                                let bidGoodsList = [];
                                if(bidGoodsMap.contains(goods.callId)) {
                                    bidGoodsList = bidGoodsMap.get(goods.callId);
                                }
                                bidGoodsList.push(goods);
                                bidGoodsMap.put(goods.callId, bidGoodsList);
                                //
                                let callGoods = callGoodsMap[goods.callId];
                                // console.log(JSON.encode(callGoods));
                                let sumPrice = callGoods.sumPrice || 0;
                                let sumQuantity = callGoods.sumQuantity || 0;
                                callGoods.sumPrice = sumPrice + goods.price;
                                callGoods.sumQuantity = sumQuantity + 1;
                            }
                        } else {
                            if(goodsFlag) {
                                let callBidGoodsList = callBidDocInfo.callBidGoodsList;
                                for(let i = 0; i < callBidGoodsList.length; i++) {
                                    let goods = callBidGoodsList[i];
                                    let bidGoodsList = [];
                                    if(bidGoodsMap.contains(goods.id)) {
                                        bidGoodsList = bidGoodsMap.get(goods.id);
                                    }
                                    bidGoodsList.push(null);
                                    bidGoodsMap.put(goods.callId, bidGoodsList);
                                }
                            }
                        }
                        //
                        let servcList = bidItem.bidServcList;
                        if(servcList != null && servcList.length > 0) {
                            for(let i = 0; i < servcList.length; i++) {
                                let servc = servcList[i];
                                //
                                let bidServcList = [];
                                if(bidServcsMap.contains(servc.callId)) {
                                    bidServcList = bidServcsMap.get(servc.callId);
                                }
                                bidServcList.push(servc);
                                bidServcsMap.put(servc.callId, bidServcList);
                                //
                                let callServc = callServcsMap[servc.callId];
                                let sumPrice = callServc.sumPrice || 0;
                                let sumQuantity = callServc.sumQuantity || 0;
                                callServc.sumPrice = sumPrice + servc.price;
                                callServc.sumQuantity = sumQuantity + 1;
                            }
                        } else {
                            if(servcFlag) {
                                let callBidServcList = callBidDocInfo.callBidServcList;
                                for(let i = 0; i < callBidServcList.length; i++) {
                                    let servc = callBidServcList[i];
                                    let bidServcList = [];
                                    if(bidServcsMap.contains(servc.id)) {
                                        bidServcList = bidServcsMap.get(servc.id);
                                    }
                                    bidServcList.push(null);
                                    bidServcsMap.put(servc.callId, bidServcList);
                                }
                            }
                        }
                    }
                }
                this.bidGoodsMap = bidGoodsMap.toObject();
                this.bidServcsMap = bidServcsMap.toObject();
                this.callGoodsMap = Utils.merge({}, callGoodsMap);
                this.callServcsMap = Utils.merge({}, callServcsMap);
                this.bidParityList = bidParityList;
            },
            getCallBidDocInfo: function () {
                //
                let callBidDocId = this.callBidDocId;
                let store = getStore() || {};
                let bidParityList = store.get(this.bidParityKey) || [];
                if(bidParityList != null && bidParityList.length > 0) {
                    let bidParity = bidParityList[0];
                    callBidDocId = bidParity.callDocId;
                }
                //
                let self = this;
                let postData = {};
                postData.id = callBidDocId;
                let lastMsgBoxDlg = MsgBox.loading();
                callBidApi.getCallBidDocInfo(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type == 'info') {
                        let callBidDocInfo = result.data;
                        if(typeof callBidDocInfo.reqRegCapital == 'number') {
                            callBidDocInfo.reqRegCapital = (callBidDocInfo.reqRegCapital / 10000).round(4);
                        }
                        let goodsList = callBidDocInfo.callBidGoodsList;
                        if(goodsList != null && goodsList.length > 0) {
                            for(let i = 0; i < goodsList.length; i++) {
                                let goods = goodsList[i];
                                self.callGoodsMap[goods.id] = goods;
                            }
                        }
                        let bidServcList = callBidDocInfo.callBidServcList;
                        if(bidServcList != null && bidServcList.length > 0) {
                            for(let i = 0; i < bidServcList.length; i++) {
                                let bidServc = bidServcList[i];
                                self.callServcsMap[bidServc.id] = bidServc;
                            }
                        }
                        if(callBidDocInfo.goodsFlag == false) {
                            self.activeName = "servc";
                        }
                        self.callBidDocInfo = callBidDocInfo;
                        self.getBidParityList();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            removeBidParity: function (index) {
                let self = this;
                this.$confirm('确定要移除吗 ?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let store = getStore() || {};
                    let bidParityList = store.get(self.bidParityKey) || [];
                    if(bidParityList.length <= 1) {
                        MsgBox.warning("至少保留一个！");
                        return;
                    }
                    bidParityList.splice(index, 1);
                    store.set(self.bidParityKey, bidParityList);
                    self.getBidParityList();
                    self.$emit('notity-syncRefresh', true);
                });
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                result.type = "info";
                result.applyDesc = self.desc;
                return result;
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/callbid/BidParity.vue